// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"825395b0","489":"d7afcc49","622":"81ffc47e","725":"39398415","815":"d6a654f2","839":"e3713e1d","878":"2c6afa1f","890":"0b3cb2e8","910":"afb8fdc0"}[chunkId] + ".chunk.js";
};